// Auto-generated by: https://github.com/pmndrs/gltfjsx

import React, { useRef } from "react";
import * as THREE from "three";
import { shaderMaterial, useGLTF, useTexture } from "@react-three/drei";
import { extend, useFrame } from "@react-three/fiber";

import state from "./config/WeatherStates.json";
import { rainVertexShader, rainFragmentShader } from "./data/shaders";

const RainShaderMaterial = shaderMaterial(
  // Uniforms
  {
    u_time: 0,
    u_wind_dir: new THREE.Vector2(),
    u_wind_speed: 1.0,
    u_rain_speed: 0,
    u_rain_density: 0,
    u_skycolor: new THREE.Color("#ffffff"),
    u_color: new THREE.Color("#ffffff"),
    u_color_texture: new THREE.Texture(),
  },
  // Vertex Shader
  rainVertexShader,
  // Fragment Shader
  rainFragmentShader
);

extend({ RainShaderMaterial });

export default function Rain({ props, weather }) {
  const matRef = useRef();

  useFrame(({ clock }) => (matRef.current.u_time = clock.getElapsedTime()));

  const { nodes } = useGLTF("./assets/rain.gltf"); // rain mesh - javi agenjo's
  const [rainTexture] = useTexture([require("./data/textures/rain.png")]); // raindrops texture - javi agenjo's
  rainTexture.wrapS = rainTexture.wrapT = THREE.RepeatWrapping;

  const rainState = weather["rainState"]; // rain density, speed is half the value
  const windDirection = weather["windDirection"];
  const windSpeed = state["seaState"][weather["seaState"]]["windSpeed"];

  return (
    <group
      {...props}
      dispose={null}
      position-y={10}
      scale={0.8}
      renderOrder={1}
    >
      <mesh geometry={nodes.Box010.geometry}>
        <rainShaderMaterial
          ref={matRef}
          u_wind_dir={windDirection}
          u_wind_speed={windSpeed}
          u_rain_density={rainState}
          u_rain_speed={rainState * 0.5}
          u_color_texture={rainTexture}
          transparent
          depthWrite={false}
          side={THREE.DoubleSide}
          visible={rainState === 0.0 ? false : true}
        />
      </mesh>
    </group>
  );
}

useGLTF.preload("./assets/rain.gltf");
